





import { defineComponent } from '@vue/composition-api';

const Index = defineComponent({
  // setup() {},
});

export default Index;
